import { POST } from "../APiHelper/API"


export const getConversationForTeam = (fixture_id, team_id, onSuccess, onError) => {
    const data = {
        fixture_id: fixture_id,
        team_id: team_id
    }
    POST("/api/v1/conversations/conversation_for_team", data, onSuccess, onError)
}